import React from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import logo from "../../src/assets/logo.png"; // <-- Add your logo here
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRefresh, faSearch, faTicket, faUser } from "@fortawesome/free-solid-svg-icons";



const Header = () => {
  const location = useLocation();
  const toTitleCase = (str) =>
    str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();

  const navigate = useNavigate();

  // const handleLogout = () => {
  //   localStorage.removeItem("authToken");
  //   navigate("/");
  //    window.location.reload(); 

  // };
  const handleLogout = () => {
    localStorage.removeItem("viewPayload")
    localStorage.removeItem("userName");
    localStorage.removeItem("isLoggedIn");
    localStorage.removeItem("clickUserDetail")
    localStorage.removeItem("email");
    localStorage.removeItem("empId");
    localStorage.removeItem("role");
    window.location.href = "/"; // refresh + redirect
  };


  //   const username = localStorage.getItem("username") || "User";
  //   const role = toTitleCase(localStorage.getItem("role") || "Role");
  // console.log(role);
  //const user = JSON.parse(localStorage.getItem("user") || "{}");
  //const user = JSON.parse(localStorage.getItem("user") || "{}");
  const username = localStorage.getItem("userName") || "";
  const email = localStorage.getItem("email") || "";
  const empId = localStorage.getItem("empId") || "";
  const role = localStorage.getItem("role") || "";


  //const role = toTitleCase(localStorage.getItem("role") || "");



  return (
    <header
      className="d-flex justify-content-between align-items-center px-3 py-2 shadow-sm"
      style={{
        width: "100%",
        background: "#ffffff",
        position: "sticky",
        top: 0,
        zIndex: 1000,
      }}
    >
      {/* Left Side - Logo + Title */}
      <div className="d-flex align-items-center gap-3">
        <img
          src={logo}
          alt="Logo"
          style={{
            width: "220px",
            height: "auto",
            objectFit: "contain",
          }}
        />

        <h4 className="m-0 fw-semibold"></h4>
      </div>

      {/* Right Side - Navigation + Profile */}
      <div className="d-flex align-items-center gap-4">

        {/* Navigation */}
        {/* <nav className="d-flex gap-3">
          <Link className="fw-semibold text-decoration-none text-dark" to="/v1">
            Home
          </Link>
          <Link className="fw-semibold text-decoration-none text-dark" to="/v2">
            Dashboard
          </Link>
        </nav> */}

        {/* Profile Dropdown - hidden on Home ("/") */}
        {location.pathname !== "/" && (
          <div className="dropdown">
            <button
              className="btn dropdown-toggle fw-semibold"
              type="button"
              data-bs-toggle="dropdown"
            >
              <FontAwesomeIcon className="fa-lg me-1" icon={faUser} />
            </button>

            <ul
              className="dropdown-menu dropdown-menu-end shadow"
              style={{ zIndex: 2000 }}
            >
              <li>
                <label className="dropdown-item">{username}</label>
              </li>
              <li><hr className="dropdown-divider" /></li>
              <li>
                <button
                  className="dropdown-item text-danger fw-semibold"
                  onClick={handleLogout}
                >
                  Logout
                </button>
              </li>
            </ul>
          </div>
        )}

      </div>
    </header>
  );
};

export default Header;
